import './styles.css'

import { memo } from 'react'

interface ICornerBadgeProps {
  text: string
}

const CornerBadge: React.FC<ICornerBadgeProps> = memo(({ text }) => (
  <div className="corner-badge-container">
    <div className="corner-badge">{text}</div>
  </div>
))

export { CornerBadge }
